"use client";
import * as React from "react";


export default function Cta() {
  return (
    <div className="flex flex-wrap items-center justify-between w-full max-w-7xl gap-5 mx-auto px-5 md:px-8 lg:px-0 py-12 lg:py-[4.5rem] lg:flex-nowrap rounded-lg">
      <div className="flex-grow text-center lg:text-left">
        <h2 className="text-2xl font-medium lg:text-3xl">
          Build with Bishop Mercier in Montreal
        </h2>
        <p className="mt-2 font-medium lg:text-xl">
          Expert construction for homes, businesses, and industry
        </p>
      </div>
      <div className="flex-shrink-0 w-full text-center lg:w-auto">
        <a
          href="/contact"
          className="inline-block text-white bg-primary py-3 mx-auto text-lg font-medium text-center rounded-md px-7 lg:px-14 lg:py-5"
        >
          <span className="lg:text-[1.3rem]">Get In Touch</span>
        </a>
      </div>
    </div>
  );
}
